import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { GlobalStyle } from './styles/GlobalStyles';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import SuccessPage from './pages/SuccessPage';
import ErrorPage from './pages/ErrorPage';

const AppContainer = styled.div.attrs({
  className: 'app-container'
})`
  min-height: 100vh;
  position: relative;
  color: white;
  font-family: 'CocomatPro', 'Arial', sans-serif;
  overflow-x: hidden;
`;

const BackgroundLayer1 = styled.div.attrs({
  className: 'background-layer-1'
})`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('/backgrounds/background-3.png') repeat;
  z-index: 1;
`;

const BackgroundLayer2 = styled.div.attrs({
  className: 'background-layer-2'
})`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 60%;
  height: 70%;
  background: url('/backgrounds/background-2.png') right bottom/contain no-repeat;
  z-index: 2;
  
  @media (max-width: 768px) {
    width: 80%;
    height: 50%;
  }
`;


const GradientOverlayTop = styled.div.attrs({
  className: 'gradient-overlay-top'
})`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 50%, transparent 100%);
  z-index: 4;
  pointer-events: none;
`;

const GradientOverlayBottom = styled.div.attrs({
  className: 'gradient-overlay-bottom'
})`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70%;
  background: linear-gradient(to top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.8) 50%, transparent 100%);
  z-index: 4;
  pointer-events: none;
`;

const GradientOverlayMid = styled.div.attrs({
  className: 'gradient-overlay-mid'
})`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 50%, transparent 100%);
  z-index: 6;
  pointer-events: none;
`;

const ContentWrapper = styled.div.attrs({
  className: 'content-wrapper'
})`
  position: relative;
  z-index: 10;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.div.attrs({
  className: 'main-content'
})`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  
  @media (max-width: 768px) {
    
  }
`;

const HeroAndPricing = styled.div.attrs({
  className: 'hero-and-pricing'
})`
  display: flex;
  align-items: flex-start;
  justify-content: right;
  gap: 60px;
  max-width: 1400px;
  width: 100%;
  margin-top: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 0;
    justify-content: center;
  }
`;

const HeroContent = styled.div.attrs({
  className: 'hero-content'
})`
  flex: 0 0 auto;
  max-width: 90%;
`;

const PricingSection = styled.div.attrs({
  className: 'pricing-section'
})`
  flex: 0 0 350px;
  position: relative;
  z-index: 10;
  
  @media (max-width: 1024px) {
    flex: none;
    width: 100%;
    max-width: 500px;
  }
`;

// Shared Background Components
export const BackgroundVideo = styled.video.attrs({
  className: 'background-video'
})`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <AppContainer>
        <Router>
          <BackgroundLayer1 />
          <BackgroundLayer2 />
          <GradientOverlayTop />
          <GradientOverlayBottom />
          <GradientOverlayMid />
          <ContentWrapper>
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/error" element={<ErrorPage />} />
            </Routes>
          </ContentWrapper>
        </Router>
      </AppContainer>
    </>
  );
}

// Export styled components for reuse in pages
export { 
  AppContainer, 
  MainContent, 
  HeroAndPricing, 
  HeroContent, 
  PricingSection,
  ContentWrapper 
};

export default App;
